var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgOrderStateOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 7,
  r: 6,
  stroke: "#62C440",
  strokeDasharray: "1.4 1.4",
  strokeWidth: 1.4
})));
export default SvgOrderStateOutline;